export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11052.8a554424.jpg";